import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import { Button } from "reactstrap";

import "./switch-button.scss";

export class SwitchButton extends React.Component {
  state = {
    active: this.props.active,
  };

  handleClick = () => {
    this.setState(
      {
        active: !this.state.active,
      },
      () => this.props.onChange(this.state.active),
    );
  };

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      this.setState({ active: this.props.active });
    }
  }

  get active() {
    return this.state.active && this.props.active;
  }

  render() {
    return (
      <Button
        className={classNames("switch-button__container", {
          "switch-button__container--active": this.active,
          "switch-button__container--disabled": this.props.disabled,
        })}
        onClick={!this.props.disabled ? this.handleClick : undefined}
      >
        <div
          className={classNames("switch-button__text--on", {
            "switch-button__text--visible": this.active,
          })}
        >
          On
        </div>
        <div
          className={classNames("switch-button__text--off", {
            "switch-button__text--visible": !this.active,
          })}
        >
          Off
        </div>
        <div
          className={classNames("switch-button__knob", {
            "switch-button__knob--active": this.active,
          })}
        />
      </Button>
    );
  }
}

SwitchButton.displayName = "SwitchButton";

SwitchButton.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default SwitchButton;
